module.exports = __webpack_public_path__ + "img/left-arrow.1aa0ad06.svg";